import { render, staticRenderFns } from "./mobilePage.vue?vue&type=template&id=4c0ac6c6&scoped=true"
import script from "./mobilePage.vue?vue&type=script&lang=js"
export * from "./mobilePage.vue?vue&type=script&lang=js"
import style0 from "./mobilePage.vue?vue&type=style&index=0&id=4c0ac6c6&prod&lang=scss&scoped=true"
import style1 from "./mobilePage.vue?vue&type=style&index=1&id=4c0ac6c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0ac6c6",
  null
  
)

export default component.exports